/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createHook } from '../../core/factories/createHook.js';

import { createPrefetchHook } from '../../core/factories/createPrefetchHook.js';
import type { GetCreatorStatsRow } from '../openapi-types.gen.js';
import { type useGetCreatorStatsArgs, useGetCreatorStatsSpec } from '../specs/users.spec.gen.js';

export type { GetCreatorStatsRow } from '../openapi-types.gen.js';
export type { useGetCreatorStatsArgs } from '../specs/users.spec.gen.js';


/**
 * Available query params (forwarded automatically; pass via the
 * hook's args): userId.
 */
const _useGetCreatorStats = createHook(useGetCreatorStatsSpec);
export const useGetCreatorStats = _useGetCreatorStats as (args: useGetCreatorStatsArgs, opts?: import('../../core/factories/createHook.js').CreateHookCallOpts) => ReturnType<typeof _useGetCreatorStats>;


/**
 * Hover/intent prefetch companion for `useGetCreatorStats`. Returns a stable
 * `(args) => Promise<void>` callback that fires the real HTTP request
 * and writes the response into the SAME cache entry the reader hook
 * observes. The component owning the callback does NOT subscribe — no
 * re-renders on data, no NATS subscription. Idempotent: TanStack
 * `prefetchQuery` is a no-op when a fresh cache entry already exists.
 *
 *     function Link({ pubkey }) {
 *       const prefetch = usePrefetchGetCreatorStats();
 *       return (
 *         <a
 *           onMouseEnter={() => prefetch({ pubkey })}
 *           onFocus={() => prefetch({ pubkey })}
 *         >…</a>
 *       );
 *     }
 */
export const usePrefetchGetCreatorStats = createPrefetchHook(useGetCreatorStatsSpec) as () => import('../../types/SdkPrefetchTask.js').SdkPrefetcher<useGetCreatorStatsArgs>;
